export enum DelarStatus {
    Rejected = -1,
    NotInit= 0,
    Pending = 1,
    Verified = 2,
  }